import styled from 'styled-components'

export const StyledSwiperContainer = styled.div`
  padding-inline: 0.5rem;
  .swiper-ltr {
    .swiper-button-next {
      right: 0;
      left: unset;
      transform: rotateY(180deg);
    }

    .swiper-button-prev {
      left: 0;
      right: unset;
      transform: rotateY(180deg);
    }
  }
`

export const StyledSubForwardBtn = styled.button<{
  isHidden: boolean
}>`
  position: absolute;
  left: 0;
  z-index: 10;
  gap: 10px;
  border: none;
  pointer-events: all;
  cursor: pointer;
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  box-shadow: none;
  height: 16px;
  background-color: transparent;
  top: -12.5%;
  padding: 0;
  padding-inline-end: 12px;
  width: 16px;
`
export const StyledSubPrevButton = styled.button<{
  isHidden: boolean
}>`
  position: absolute;
  right: 0;
  z-index: 10;
  gap: 10px;
  border: none;
  pointer-events: all;
  cursor: pointer;
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  box-shadow: none;
  height: 16px;
  background-color: transparent;
  top: -12.5%;
  padding: 0;
  padding-inline-end: 12px;
  width: 16px;
`
export const StyledSubArrowImg = styled.img`
  position: absolute;
`
